<template>
  <div v-if="show" class="incomplete-registration-alert">
    <template v-if="!completedRegistration">
      Silakan lengkapi profil diri Anda untuk tetap dapat menggunakan layanan.
      <a v-if="!isProfileSettingPage" @click="settingProfile()">
        Lengkapi sekarang
      </a>
    </template>
    <template v-else-if="!isOfficialEmail">
      Silakan ubah akun menjadi E-mail UGM untuk tetap dapat menggunakan
      layanan.
      <a v-if="!isChangeEmailPage" @click="changeEmail()"> Ubah sekarang </a>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "incomplete-registration-alert",
  computed: {
    ...mapGetters({
      completedRegistration: "completedRegistration",
      isOfficialEmail: "isOfficialEmail",
    }),
    isProfileSettingPage: function () {
      return this.$route.name == "profile-settings";
    },
    isChangeEmailPage: function () {
      return this.$route.name == "change-email";
    },
    show: function () {
      return !this.completedRegistration || !this.isOfficialEmail;
    },
  },
  watch: {
    show: function () {
      this.$nextTick(() => this.updateBodyStyle());
    },
  },
  methods: {
    settingProfile: function () {
      this.$router.push({ name: "profile-settings" });
    },
    changeEmail: function () {
      this.$router.push({ name: "change-email" });
    },
    getIncompleteRegistrationAlertHeight: function () {
      const el = document.querySelector(".incomplete-registration-alert");
      return el?.getBoundingClientRect().height ?? 0;
    },
    updateBodyStyle: function () {
      const height = this.getIncompleteRegistrationAlertHeight();
      document
        .querySelector(":root")
        .style.setProperty("--pt-body", height + "px");
    },
  },
  mounted: function () {
    window.addEventListener("resize", this.updateBodyStyle);
    this.updateBodyStyle();
  },
};
</script>
